import { Box, Paper, Skeleton, Typography } from "@mui/material";

interface ChartSkeletonProps {
  title?: string;
}

export const ChartSkeleton = ({ title = "" }: ChartSkeletonProps) => {
  return (
    <Paper
      sx={{
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        {title ? (
          <Typography
            variant="graphLabel"
            fontSize={24}
            sx={{
              color: "#333",
            }}
          >
            {title}
          </Typography>
        ) : (
          <Skeleton variant="text" width={200} height={36} />
        )}
      </Box>

      {/* Chart area skeleton - just a simple rectangle */}
      <Skeleton
        variant="rectangular"
        sx={{
          flex: 1,
          borderRadius: 1,
        }}
      />
    </Paper>
  );
};
